// packages import
import { Dialog, DialogContent } from '@mui/material';
import { FC } from 'react';
// others
import { CustomModalProps } from '../../../../shared/lib/interfaceTypes';

export const CustomModal: FC<CustomModalProps> = ({ isOpen, handleClose, children, maxWidth, hideBackdrop }) => (
  <Dialog open={isOpen} onClose={handleClose} maxWidth={false} sx={{ maxWidth: maxWidth, margin: 'auto', zIndex: 99999 }} fullWidth hideBackdrop={hideBackdrop}>
    <DialogContent sx={{ padding: '0px 16px 16px' }}>{children}</DialogContent>
  </Dialog>
);
